import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import type { ReactNode } from 'react';

export interface UserTextProps extends BoxProps {
  children: ReactNode;
}

const UserText = ({ children, onClick, ...props }: UserTextProps) => {
  return (
    <Box
      className="UserText"
      as="span"
      color="colorPalette.solid"
      cursor={onClick ? 'pointer' : 'default'}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      {...props}
    >
      {children}
    </Box>
  );
};

const MemoizedUserText = memo(UserText);
export { MemoizedUserText as UserText };
